export default __webpack_public_path__ + "static/media/object_bookcase2.76a3fd8e.png";